import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { SectionHeader } from "../../../Common/SharedComponents";
import { incomePaymentDetailsLabels } from "../../Resource/Contents";
import { getAgefromDateOfBirth } from "../../../../../../Shared/Utils/getAgefromDateOfBirth";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";

interface IClientDetailsProps {
    data: any;
}

interface IClientDetailseState {}

export class ClientDetails extends FormComponent<IClientDetailsProps, IClientDetailseState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { data } = this.props;

        return (
            <>
                {SectionHeader("Client details")}
                <div className="row">
                    <span className="col-sm-6 h4">{incomePaymentDetailsLabels.clientAge}</span>
                    <span className="col-sm-6 pl-0" data-test="clientage">
                        {getAgefromDateOfBirth(JsonDateParser.toDateNoOffset(data?.DateOfBirth))}
                    </span>
                </div>
                <hr />
            </>
        );
    }
}
